import aos from 'aos'

export default function aosInitiate(): void {
  aos.init({ once: true })
}
